import { render } from "./Form1Ver2.vue?vue&type=template&id=14d2cc70&scoped=true"
import script from "./Form1Ver2.vue?vue&type=script&lang=js"
export * from "./Form1Ver2.vue?vue&type=script&lang=js"

import "./Form1Ver2.vue?vue&type=style&index=0&id=14d2cc70&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d2cc70"]])

export default __exports__